@use 'styles/mixins/breakpoints' as *;

.withResponsive {
    gap: inherit;
}

@include tabletAndBelow {
    .withResponsive {
        display: flex;
        flex-direction: column;
    }
}
